import React from "react";
import { SwitchField } from "components/formfields";

const NotificationSettingForm = ({ onSwitchChange }) => {
  return (
    <div>
      <div className="flex gap-4 items-start border-0 border-b dark:border-b-gray-800 py-4">
        <div className="pt-1">
          <SwitchField
            checkedChildren={true}
            unCheckedChildren={false}
            name={"isPushNotification"}
            onChange={(value) => onSwitchChange("isPushNotification", value)}
          />
        </div>
        <div className="flex flex-col">
          <p className="font-semibold text-lg dark:text-white">
            Push notifications
          </p>
          <p className="text-xs text-[#737373]">
            Autopayout occurs at the end of each month.
          </p>
        </div>
      </div>
      <div className="flex gap-4 items-start border-0 border-b dark:border-b-gray-800 py-4">
        <div className="pt-1">
          <SwitchField
            checkedChildren={true}
            unCheckedChildren={false}
            name={"isNotificationSound"}
            onChange={(value) => onSwitchChange("isNotificationSound", value)}
          />
        </div>
        <div className="flex flex-col">
          <p className="font-semibold text-lg dark:text-white">
            Notification sound
          </p>
          <p className="text-xs text-[#737373]">
            Autopayout occurs at the end of each month.
          </p>
        </div>
      </div>
      <div className="flex gap-4 items-start border-0 border-b dark:border-b-gray-800 py-4">
        <div className="pt-1">
          <SwitchField
            checkedChildren={true}
            unCheckedChildren={false}
            name={"isEmailNotification"}
            onChange={(value) => onSwitchChange("isEmailNotification", value)}
          />
        </div>
        <div className="flex flex-col">
          <p className="font-semibold text-lg dark:text-white">
            Email notifications
          </p>
          <p className="text-xs text-[#737373]">
            Autopayout occurs at the end of each month.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettingForm;
